import React, { useContext } from "react";
import styles from "./index.module.scss";
import ReplyItem from "../ReplyItem";
import ReplyEditor from "../ReplyEditor";
import { AnswerContent, DiscussContent } from "../../context";
import { ReplyItemData } from "../../../../../API/discuss";

interface RepliesProps {
    data: ReplyItemData[];
}

export default function Replies({ data }: RepliesProps) {
    const { replyCount } = useContext(AnswerContent);
    const { isDead } = useContext(DiscussContent);

    return (
        <div className={styles.root}>
            {!isDead && (
                <div className={styles.top}>
                    <ReplyEditor />
                </div>
            )}

            {data.length !== 0 && (
                <div className={styles.main}>
                    <div className={styles.listTop}>{replyCount}条评论</div>

                    <div className={styles.list}>
                        {data.map(item => (
                            <ReplyItem key={item.uuid} data={item} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
